const initialState = () => ({
  hhaxEndpoints: [],
})

const getters = {
  HHAX_ENDPOINTS: state => state.hhaxEndpoints,
}

const mutations = {
  RESET_STATE (state) {
    Object.assign(state, initialState())
  },
  SET_CONFIG (state, payload) {
    state.hhaxEndpoints = payload.hhaxEndpoints
  },
}

export default {
  namespaced: true,
  state: initialState(),
  getters,
  mutations,
}
